module.exports = __webpack_public_path__ + "static/media/avatar.511718fc.svg";